import React from 'react';
import { Navigate } from 'react-router-dom';

export interface IProtectedRoute {
  isAuth: boolean;
  employee: any;
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<IProtectedRoute> = ({ isAuth, children }) => {
  if (!isAuth) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
